import React, { useState } from 'react'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import infoIcon from '../../../assets/icons/iconinfo.svg';
import LeftArrow from '../../../assets/icons/arrowLeft.svg'
import RightArrow from '../../../assets/icons/arrowRight.svg'
import LightBar from '../../../assets/icons/barsLight.svg'
import DarkBar from '../../../assets/icons/barsDark.svg'
import SearchIcon from '../../../assets/icons/search.svg'
import { useStyles, StyledTableCell, StyledTableRow } from "./CreditsStyle";
export default function Credits({ headings, data }) {
    const styles = useStyles();
    const classes = useStyles();
    const [searchVal, setSearchVal] = useState('');
    return (
        <>
            <div className={styles.tablesContainer}>
                <div className={styles.direction}>
                    <p className={styles.tableTitleCredit}>Credits</p>
                    <div className={styles.grayIcon}><img src={infoIcon} alt="info" className={styles.iconImage} /></div>
                </div>
                <div className={styles.tableSubDiv}>
                    <div className={styles.tablesubAvailable}>Available Credits</div>
                    <div className={styles.tableTitleCreditPrice}>$ 299.10 USD</div>
                    <div className={styles.tableSubCredit}>Credit Code</div>
                    <div>
                        <input type="text" placeholder="Insert credit code" className={styles.subTableInput} />
                    </div>
                    <div>
                        <button className={styles.subTableButton}>Claim credits</button>
                    </div>
                </div>
                <div className={styles.searchAndButtonsRow}>
                    <div className={styles.inputWithIconContainer}>
                        <input onChange={(e) => setSearchVal(e.target.value)} className={styles.searchInput} type="text" placeholder='Search by credit code.......' />
                        <div className={styles.iconContainer1}>
                            <img src={SearchIcon} alt="icon" />
                        </div>
                    </div>
                    <div className={styles.btnsRow}>
                        <p className={styles.creditNumber}>1 Credit</p>
                        <div className={styles.allBtnsContainer}>
                            <div className={styles.twoBtnsContainer}>
                                <div className={styles.singleBtnContainer}>
                                    <img className={styles.iconImg} src={LeftArrow} alt="icon" />
                                </div>
                                <div className={styles.singleBtnContainer}>
                                    <img className={styles.iconImg} src={RightArrow} alt="icon" />
                                </div>
                            </div>
                            <div className={styles.threeBtnsContainer}>
                                <div className={styles.singleBtnContainer}>
                                    <img className={styles.iconImg} src={LightBar} alt="icon" />
                                </div>
                                <div className={styles.singleBtnContainer}>
                                    <img className={styles.iconImg} src={DarkBar} alt="icon" />
                                </div>
                                <div className={styles.singleBtnContainer}>
                                    <img className={styles.iconImg} src={LightBar} alt="icon" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <TableContainer component={Paper} className={classes.eventContainer} >
                    <Table className={classes.table} size="medium" aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                {
                                    headings?.map((item) => {
                                        return (
                                            <StyledTableCell>{item}</StyledTableCell>
                                        )
                                    })
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            {
                                data?.filter((item) => {
                                    if (item?.CreditCode.toLowerCase().includes(searchVal.toLowerCase())) {
                                        return item;
                                    }
                                })
                                    ?.map((item, i) => {
                                        return (
                                            <StyledTableRow key={i}>
                                                <StyledTableCell >{item?.CreditCode}</StyledTableCell>
                                                <StyledTableCell >{item?.CreditType}</StyledTableCell>
                                                <StyledTableCell >{item?.Credit}</StyledTableCell>
                                                <StyledTableCell >{item?.RemainingCredit}</StyledTableCell>
                                                <StyledTableCell >{item?.CreditStartDate}</StyledTableCell>
                                                <StyledTableCell >{item?.CreditExpiryDate}</StyledTableCell>
                                            </StyledTableRow>
                                        )
                                    })
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

        </>

    )
}
